export const environment = {
  envName: 'dev',
  sentryDsn:
    'https://f87bf9aa342249c418513cd7860eb5dd@o4510386478252032.ingest.de.sentry.io/4510872229249104',
  api: {
    protocol: undefined,
    hostname: 'www.api.dev.grantpilot.df-tech.cz',
    port: '443',
  },
};
